<template>
    <div>
        <div class="vx-row">
            <div class="vx-col xl:w-2/3 lg:w-3/4 w-full mx-auto">
                <vx-card :title='$t("SubmitRequest")'>
                    <div class="vx-row w-full">
                        <div class="vx-col xl:w-1/2 lg:w-1/2 w-full">
                            <p class="mt-6">{{$t("Name")}}</p>
                            <vs-input v-model="addTaskObject['title']" style="width: 100%"></vs-input>
                            <p class="mt-6">{{$t("BranchOffice")}}</p>
                            <vs-select autocomplete class="selectExample w-full" v-model="addTaskObject['branch_office_id']">
                                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in branchOffices" />
                            </vs-select>
                        </div>
                        <div class="vx-col xl:w-1/2 lg:w-1/2 w-full">
                            <p class="mt-6">{{$t("Description")}}</p>
                            <vs-textarea v-model="addTaskObject['description']" style="min-height: 150px" class="w-full mb-6" />
                        </div>
                        <vs-button :disabled="addTaskObject['title'].length === 0 || addTaskObject['description'].length === 0" id="newTaskButton" color="success" class="mt-6; ml-6" @click="addTask">{{$t("Add")}}</vs-button>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        data() {
            return {

                addTaskObject: {
                    description: '',
                    title: '',
                },
                branchOffices: [],

            }
        },
        methods: {
            updateBranchOffices(){
                const thisIns = this;
                this.$http.get('/api/v1/branch_offices/')
                    .then(function (response) {
                        thisIns.branchOffices = response.data;
                        if(thisIns.branchOffices.length > 0) thisIns.addTaskObject['branch_office_id'] = thisIns.branchOffices[0].id;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addTask() {
                const thisIns = this;
                this.$http.post('/api/v1/tasks/', this.addTaskObject)
                    .then(function () {
                        thisIns.addTaskObject = {
                            description: '',
                            title: '',
                            branch_office_id: thisIns.addTaskObject.branch_office_id
                        };
                        thisIns.$router.push({ name: 'allTasks'});
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: this.$('TaskAddingFailed'),
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
        },
        created() {
            this.updateBranchOffices()
        },
    }
</script>
